<ng-template [sbmodal]="'sbPreviewListModal'">
  <sb-custom-modal [templateId]="'sbPreviewListModal'">
    <div slot="body">
      <sb-preview-list [attributeType]="'CLIENT'" [isInModalContext]="'sbPreviewListModal'"></sb-preview-list>
    </div>
  </sb-custom-modal>
</ng-template>

<div class="row">
  <div class="col-12">
    <sb-card>
      <div card-header>
        <h3>{{schedule ? schedule.name : ''}}</h3>
        <small><span class="blue mr-1">{{ schedule?.slots?.length }}</span> {{ 'lang.globals.slots' | translate }}</small>
      </div>
      <div card-header-more>
        <ng-container *ngPermissions="permissionService.Permission.playback_schedule_edit">
          <button class="btn btn-primary mr-1" [disabled]="!editMode" (click)="addEntry()">
            <sb-icon class="mr-1" icon="plus"></sb-icon>
            {{'lang.scheduleDetails.addSlot' | translate}}
          </button>
          <button class="btn btn-primary" *ngIf="!editMode" (click)="enableEditMode()">
            <sb-icon class="mr-1" icon="edit"></sb-icon>
            {{'lang.scheduleDetails.editSlots' | translate}}
          </button>
          <button class="btn btn-success" *ngIf="editMode" [disabled]="maxPercentage < 0" (click)="updateSchedule()">
            <sb-icon class="mr-1" icon="save"></sb-icon>
            {{'lang.scheduleDetails.saveSlots' | translate}}
          </button>
          <button class="btn btn-danger ml-1" *ngIf="editMode" (click)="cancelEditMode()">
            <sb-icon class="mr-1" icon="cancel"></sb-icon>
            {{'lang.globals.cancel' | translate}}
          </button>

        </ng-container>
      </div>
      <div card-fit>
        @if (editMode && hasCircularDependencyInFallback) {
          <div class="tw-p-3">
            <h4 class="tw-text-sbRed-500">{{ 'lang.globals.circularDependencyWarning' | translate }}</h4>
          </div>
        }
        <table class="table">
          <thead>
          <tr>
            <th>#</th>
            <th>{{'lang.scheduleDetails.slotType' | translate}}</th>
            <th>Name</th>
            <th>{{'lang.scheduleDetails.contentCull' | translate}}</th>
            <th>{{'lang.scheduleDetails.clientCull' | translate}}</th>
            <th>{{'lang.globals.deals' | translate}}</th>
            <th>{{'lang.globals.fallback' | translate}}</th>
            <th *ngIf="!editMode">{{'lang.globals.share' | translate}}</th>
            <th>{{'lang.globals.minDuration' | translate}}</th>
            <th>{{'lang.globals.duration' | translate}}</th>
            <th>{{'lang.globals.percentage' | translate}}</th>
            <th class="text-end">{{'lang.globals.actions' | translate}}</th>
          </tr>
          </thead>
          <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr *ngFor="let slot of this.schedule?.slots;" cdkDrag cdkDragLockAxis="y">
            <td class="col-sm">
              {{slot?.orderNum + 1}}
              <!--
              TODO Backend needs fix since id is now combined key
              <sb-tags *ngIf="!editMode && permissionService.hasPermission(permissionService.Permission.tag_list)"
                       [resolveInComponent]="true" [dtoType]="tagService.TaggableDTO.PlaybackScheduleSlotFull"
                       [dtoId]="slot.id"></sb-tags>
                       -->

            </td>
            <td class="col-md">
              <div class="card mr-1 mb-0"
                   style="height: 100%; width: 100%; display: inline-block; overflow: hidden; color:white"
                   [ngClass]="util.getSlotType(slot, 'Class')" *ngIf="slot" (click)="showClients(slot?.clientCull?.id)">
                  <span [innerHTML]="util.getSlotType(slot, 'Name') | truncate : 25"
                        class="d-flex align-items-center justify-content-center px-4 py-3 "></span>
              </div>
            </td>
            <td class="col-md">
              <ng-container *ngIf="editMode">
                <div class="input-group" style="width: 100px;">
                  <input type="text" class="form-control" [(ngModel)]="slot.name"/>
                </div>
              </ng-container>
              <ng-container *ngIf="!editMode">
                <span [innerHTML]="slot?.name | truncate: 15"></span>
              </ng-container>
            </td>
            <td class="col-md">
              <button [disabled]="!editMode" class="btn btn-outline-secondary "
                      (click)="setCull(slot, 'CONTENT')">
                <sb-icon icon="management"></sb-icon>
                {{slot.contentCull ? (slot.contentCull.name ?
                slot.contentCull.name : '...') : '...'}}
              </button>
            </td>
            <td class="col-md">
              <button [disabled]="!editMode" class="btn btn-outline-secondary "
                      (click)="setCull(slot, 'CLIENT')">
                <sb-icon icon="companyClient"></sb-icon>
                {{slot?.clientCull ? (slot?.clientCull?.name ? slot?.clientCull?.name
                : '...') : '...'}}
              </button>
            </td>
            <td class="col-md">
              <button (click)="editDeals(slot)" [disabled]="!editMode" class="btn btn-outline-secondary ">
                <sb-icon icon="budgetCoin" class="mr-1"></sb-icon>
                <ng-container *ngIf="slot?.deals && slot?.deals?.length > 0">
                  <ng-container *ngFor="let deal of slot?.deals">
                      <span
                        class="mr-1">{{deal?.name && deal?.identifier ? (deal?.name + '(' + deal?.identifier + ')') : (deal?.name ? deal?.name : deal?.identifier)}}</span>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="slot?.deals && slot?.deals.length === 0">
                  ...
                </ng-container>
              </button>
            </td>
            <td class="col-md">
              <button (click)="editFallback(slot)" [disabled]="!editMode" class="btn btn-outline-secondary ">
                <sb-icon icon="crossway" class="mr-1"></sb-icon>
                <ng-container *ngIf="slot?.fallbackOrderNum && slot?.fallbackOrderNum?.length > 0">
                  <span class="mr-1" [innerHTML]="getOrderNums(slot).join(',')|truncate: 12"></span>
                </ng-container>
                <ng-container *ngIf="slot?.fallbackOrderNum && slot?.fallbackOrderNum.length === 0">
                  ...
                </ng-container>
              </button>
            </td>
            <ng-container *ngIf="editMode; else noEditMode">
              <td class="col-md">
                <div class="input-group" style="width: 100px;">
                  <input type="number" class="form-control" [(ngModel)]="slot.minDuration"/>
                  <div class="input-group-append">
                    <span class="input-group-text h-100">s</span>
                  </div>
                </div>
              </td>
              <td class="col-md">
                <div class="input-group" style="width: 100px;">
                  <input type="number" class="form-control" [(ngModel)]="slot.duration"/>
                  <div class="input-group-append">
                    <span class="input-group-text h-100">s</span>
                  </div>
                </div>
              </td>
              <td class="col-md">
                <div class="input-group" style="width: 100px;">
                  <input type="number" class="form-control" [min]="0" [ngModel]="slot.percentage"
                         (ngModelChange)="adjustMaxPercentage(slot, $event)"/>
                  <div class="input-group-append">
                    <span class="input-group-text h-100">&#x25;</span>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-template #noEditMode>
              <td class="col-md">
                {{slot?.share}}&nbsp;&#x25;
              </td>
              <td class="col-md">
                {{slot?.minDuration}}
                <ng-container *ngIf="slot?.minDuration || slot?.minDuration === 0">&nbsp;s</ng-container>
              </td>
              <td class="col-md">
                {{slot?.duration}}
                <ng-container *ngIf="slot?.duration || slot?.duration === 0">&nbsp;s</ng-container>
              </td>
              <td class="col-md">
                {{slot?.percentage}}
                <ng-container *ngIf="slot?.percentage || slot?.percentage === 0">&nbsp;&#x25;</ng-container>
              </td>
            </ng-template>
            <td class="col-md text-end">
              <ng-container *ngIf="editMode; else budgetButtonNoEditMode">
                <ng-container
                  *ngIf="slot?.currency || slot?.minCPM || slot?.minCPMDuration || slot?.minCPS; else budgetButtonAssign">
                  <button class="btn btn-warning mr-1" (click)="showPricing(slot, !editMode)">
                    <sb-icon icon="coin"></sb-icon>
                  </button>
                </ng-container>
                <ng-template #budgetButtonAssign>
                  <button class="btn btn-primary mr-1" (click)="showPricing(slot, !editMode)">
                    <sb-icon icon="coin"></sb-icon>
                  </button>
                </ng-template>
              </ng-container>
              <ng-template #budgetButtonNoEditMode>
                <ng-container *ngIf="slot?.currency || slot?.minCPM || slot?.minCPMDuration || slot?.minCPS">
                  <button class="btn btn-warning mr-1" (click)="showPricing(slot, !editMode)">
                    <sb-icon icon="coin"></sb-icon>
                  </button>
                </ng-container>
              </ng-template>
              <button [disabled]="!editMode" class="btn btn-danger mr-1" (click)="deleteEntry(slot)">
                <sb-icon icon="trash"></sb-icon>
              </button>
              <button [disabled]="!editMode" class="btn btn-hover-primary" cdkDragHandle>
                <sb-icon icon="drag"></sb-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </sb-card>
  </div>
</div>
<ng-container *sbPageAction>
  <a *ngPermissions="permissionService.Permission.playback_schedule_edit"
     [sbRouterLink]="util.RoutingID.scheduleEdit" [pathParams]="[{id: 'scheduleID', value: schedule?.id}]"
     [queryParams]="{returnTo: util.getPageLink()}">
    <button class="btn btn-primary">
      <sb-icon icon="edit" class="mr-1"></sb-icon>
      {{'lang.scheduleDetails.editScheduleSettings' | translate}}
    </button>
  </a>
</ng-container>

